type ResolvePolicyResolvedIdParams = {
  isHotel?: boolean;
  queryPolicyResolvedId?: any;
  cbtPolicyResolvedId?: any;
  cbtPassengersFormPolicyResolvedId?: any;
};

function normalizePolicyResolvedId(policyResolvedId?: any) {
  return Array.isArray(policyResolvedId)
    ? policyResolvedId[0]
    : policyResolvedId;
}

export function resolvePolicyResolvedId({
  isHotel,
  queryPolicyResolvedId,
  cbtPolicyResolvedId,
  cbtPassengersFormPolicyResolvedId,
}: ResolvePolicyResolvedIdParams) {
  const normalizedQueryPolicyResolvedId = normalizePolicyResolvedId(
    queryPolicyResolvedId
  );

  if (isHotel) {
    return normalizedQueryPolicyResolvedId;
  }

  return (
    cbtPolicyResolvedId ||
    cbtPassengersFormPolicyResolvedId ||
    normalizedQueryPolicyResolvedId
  );
}
